import { createSlice } from '@reduxjs/toolkit';
export const saveNewCourseSlice = createSlice({
  name: 'saveNewCourse',
  initialState: {
    chName: '',
    engName: '',
    professor: '',
    realId: '',
    department: '',
    selectedDepartment: { id: '' },
    courseType: '',
    credit: '',
    semester: '',
    selectedSemester: { id: '' },
  },
  reducers: {
    update: (state, action) => {
      const {
        chName = '',
        engName = '',
        professor = '',
        realId = '',
        department = '',
        selectedDepartment = { id: '' },
        courseType = '',
        credit = '',
        semester = '',
        selectedSemester = { id: '' },
      } = action.payload;
      state.chName = chName;
      state.engName = engName;
      state.professor = professor;
      state.realId = realId;
      state.department = department;
      state.selectedDepartment = selectedDepartment;
      state.courseType = courseType;
      state.credit = credit;
      state.semester = semester;
      state.selectedSemester = selectedSemester;
    },
    clearNewCourse: (state) => {
      state.chName = '';
      state.engName = '';
      state.professor = '';
      state.realId = '';
      state.department = '';
      state.selectedDepartment = { id: '' };
      state.courseType = '';
      state.credit = '';
      state.semester = '';
      state.selectedSemester = { id: '' };
    },
  },
});
export const { update, clearNewCourse } = saveNewCourseSlice.actions;
export const saveNewCourse = (state) => state.saveNewCourse;
export default saveNewCourseSlice.reducer;
